/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetScheduleRequest} from '@cash-web/protos/squareup/timecards/scheduling/reporting_service.pb'
import {GetScheduleResponse} from '@cash-web/protos/squareup/timecards/scheduling/reporting_service.pb'


export const getSchedule = (request: GetScheduleRequest, options?: CashRequestOptions) => post<GetScheduleRequest, GetScheduleResponse>("/proxy/services/squareup.timecards.scheduling.PublicSchedulingReportsService/GetSchedule", request, {...options, rejectOnError: true })